import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const iconWrapper: SxStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minWidth: (p) => p.spacing(3),
};

const contentBase: SxStyle = {
  backgroundColor: 'transparent',
  height: (p) => p.spacing(4),
  borderRadius: (p) => p.spacing(0.5),
  color: (p) => p.palette.grey[600],
  alignItems: 'center',
  ':hover': {
    backgroundColor: (p) => p.palette.grey[200],
  },
  '.highlight': {
    backgroundColor: 'transparent',
    fontWeight: 700,
  },
};

export const contentLpMb: SxStyle = {
  ...contentBase,
  paddingLeft: (p) => p.spacing(1),
  marginBottom: (p) => p.spacing(0.5),
};

export const contentLp: SxStyle = {
  ...contentBase,
  paddingLeft: (p) => p.spacing(1),
  marginBottom: 0,
};

export const contentMb: SxStyle = {
  ...contentBase,
  paddingLeft: 0,
  marginBottom: (p) => p.spacing(0.5),
};

export const contentDefault: SxStyle = {
  ...contentBase,
  paddingLeft: 0,
  marginBottom: 0,
};

export const checkboxLeftSx: SxStyle = { marginLeft: 0.5 };

export const forkBorder: SxStyle = {
  position: 'absolute',
  width: (p) => p.spacing(1),
  height: (p) => p.spacing(1.5),
  borderBottomLeftRadius: (p) => p.spacing(2),
  borderBottom: (p) => `1px solid ${p.palette.grey[400]}`,
  borderLeft: (p) => `1px solid ${p.palette.grey[400]}`,
  left: (p) => `-${p.spacing(0.5)}`,
  bottom: (p) => p.spacing(2),
};

export const metadataCount: SxStyle = {
  minWidth: (p) => p.spacing(2),
  maxWidth: (p) => p.spacing(4.5),
};

export const metadataCountProgress: SxStyle = {
  color: (p) => p.palette.grey[500],
};

export const labelWrapper: SxStyle = {
  display: 'flex',
  minWidth: 0,
};
